<template>
  <DialogRoot v-model:open="open">
    <!-- <DialogTrigger class="btn">Edit profile</DialogTrigger> -->
    <DialogPortal>
      <DialogContent class="modal-content">
        <VisuallyHidden>
          <DialogTitle as="p"></DialogTitle>
          <DialogDescription></DialogDescription>
        </VisuallyHidden>
        <iframe :src="widgetUrl" frameborder="0" height="100%" scrolling="auto" title="Boka bord" width="100%" />
      </DialogContent>
      <DialogOverlay class="modal-overlay" />
    </DialogPortal>
  </DialogRoot>
</template>

<script setup>
const route = useRoute()
const router = useRouter()

// Set open state for modal
const open = ref(false)

// Create widget URL based on widget query parameter
const widgetUrl = computed(() => {
  const params = useParseWidgetQuery(route.query?.widget)
  return useWidgetUrl(params.hash, params.mealid, params.amount, params.date, params.time)
})

// Open modal by changing open value
const openModal = () => {
  open.value = true
}

// Close modal by changing open value and reset route
const closeModal = () => {
  open.value = false
  useCloseWidget()
}

// Handle messages sent from WA Widget
const handleMessage = (event) => {
  if (event.data === 'closeWaiteraidFrame') {
    closeModal()
  }

  // if (event.data === 'reservationSuccess') {
  //   // console.log('\n\nreservationSuccess!')
  //   setTimeout(() => {
  //     // console.log('Push Route')
  //     closeModal()
  //   }, 3000)
  // }
}

// Check initial load and add event listeners
onMounted(() => {
  // Open modal on mounted 
  if (route.query?.widget) {
    openModal()
  }

  // Bind event listeners for WA messages
  window.addEventListener('message', handleMessage, false)

  // Remove event listners before unmount
  onBeforeUnmount(() => {
    window.removeEventListener('message', handleMessage)
  })
})

// Watch query changes to open Widget Modal
watch(() => route.query?.widget, () => {
  if (route.query?.widget) {
    openModal()
  }
})

// Watch close to unset widget query
watch(() => open.value, () => {
  if (route.query?.widget && open.value === false) {
    closeModal()
  }
})
</script>

<style lang="scss" scoped>
.modal-content {
  @apply fixed z-[92];
  @apply flex flex-col bg-white;
  @apply inset-0 overflow-hidden;

  @screen sm {
    @apply w-4/5 max-w-2xl top-12 left-1/2 bottom-0;
    @apply -translate-x-1/2 h-auto rounded-t-2xl;
  }
}

.modal-overlay {
  @apply fixed z-40 inset-0 bg-black/40 backdrop-blur-md;
}

@keyframes fadeInModal {
  from {
    @apply opacity-0 mt-16;
  }
  to {
    @apply opacity-100;
  }
}

@keyframes fadeOutModal {
  from {
    @apply opacity-100;
  }
  to {
    @apply opacity-0 mt-16;
  }
}

.modal-content[data-state="open"] {
  animation: fadeInModal 300ms ease-out;
}

.modal-content[data-state="closed"] {
  animation: fadeOutModal 200ms ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.modal-overlay[data-state="open"] {
  animation: fadeIn 300ms ease-out;
}

.modal-overlay[data-state="closed"] {
  animation: fadeOut 200ms ease-in;
}
</style>